import { Component, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AbstractAssigneeFilterChipComponent } from '../../abstract-custom-filters/abstract-assignee/abstract-assignee-filter-chip.component';
import { ActivityAssigneeService } from '../../../shared-services/activity-assignee.service';
import { UserWithDisplayName } from '../../../tokens-and-interfaces';

@Component({
  template: `
    <ng-container *ngIf="selectedAssigneesText(); else loading">
      <span class="test">
        {{ selectedAssigneesText() }}
      </span>
    </ng-container>
    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  `,
  providers: [],
  styleUrls: ['../common-filter-chip.component.scss'],
  imports: [CommonModule, TranslateModule],
  standalone: true,
})
export class UserFilterChipComponent extends AbstractAssigneeFilterChipComponent<UserWithDisplayName> {
  private readonly userService = inject(ActivityAssigneeService);
  getDisplayName(user: UserWithDisplayName): string {
    return user.displayName;
  }

  constructor() {
    super();
    toObservable(this.selectedAssigneeIds)
      .pipe(
        switchMap((userIds) => {
          return this.userService.getMultiUsers(userIds);
        }),
        takeUntilDestroyed(),
      )
      .subscribe((result) => {
        this.selectedAssignees.set(result);
      });
  }
}
